import { defaultFetch } from './baseApi';

export type UserType = {
	id: number;
	email: string;
	firstName: string;
	lastName: string;
};

export const getUsersByProjectId = (projectId: string) => {
	return defaultFetch<UserType[]>(`/v0/projects/${projectId}/users`);
};

export const getUserDisclaimers = () => {
	return defaultFetch<string[]>(`/v0/userdisclaimers`);
};

export const addUserDisclaimer = (code: string) => {
	return defaultFetch<{ success: boolean }>('/v0/userdisclaimers', {
		method: 'PUT',
		body: JSON.stringify({ code }),
	});
};
